/**
 * CGU - Page des Conditions Générales d'Utilisation
 * Contenu placeholder à valider par un juriste
 */
import LegalPageLayout from '../components/legal/LegalPageLayout'

export default function CGU() {
  return (
    <LegalPageLayout
      title="Conditions Générales d'Utilisation"
      lastUpdate="[DATE À DÉFINIR]"
    >
      {/* Section 1 - Objet */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          1. Objet
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600 mt-4">
          Les présentes Conditions Générales d'Utilisation (CGU) régissent
          l'accès et l'utilisation de la plateforme RISK-DATA.
        </p>
      </section>

      {/* Section 2 - Description du service */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          2. Description du service
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          RISK-DATA est un outil d'aide à la recherche destiné aux professionnels
          de la prévention des risques chimiques. La plateforme agrège et
          centralise des données toxicologiques issues de sources réglementaires
          officielles françaises et européennes (INRS, ANSES, ECHA, AGRITOX).
        </p>
      </section>

      {/* Section 3 - Nature du service (non-conseil) */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          3. Nature du service
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-amber-800">
          <p className="font-medium mb-2">Important</p>
          <p>
            RISK-DATA ne fournit aucun conseil personnalisé. L'outil met à
            disposition des données toxicologiques agrégées sans les adapter à
            la situation particulière de l'utilisateur.
          </p>
          <p className="mt-2">
            Pour toute décision engageant la santé et la sécurité des
            travailleurs, l'utilisateur doit consulter les sources officielles
            et, le cas échéant, faire appel à des professionnels qualifiés
            (médecin du travail, préventeur, consultant HSE).
          </p>
        </div>
      </section>

      {/* Section 4 - Accès et inscription */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          4. Accès et inscription
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>

      {/* Section 5 - Utilisation du service */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          5. Utilisation du service
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          L'utilisateur s'engage à utiliser le service de manière loyale et
          conformément à sa destination. Sont notamment interdits :
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600 mt-2">
          <li>L'extraction massive ou systématique des données</li>
          <li>La reproduction de la base en tout ou partie substantielle</li>
          <li>L'utilisation de robots ou scripts d'extraction automatisée</li>
          <li>La commercialisation des données extraites</li>
        </ul>
      </section>

      {/* Section 6 - Limitation de responsabilité */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          6. Limitation de responsabilité
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          L'Éditeur décline toute responsabilité :
        </p>
        <ul className="list-disc list-inside space-y-1 text-gray-600 mt-2">
          <li>En cas d'erreur, inexactitude ou omission dans les données présentées</li>
          <li>En cas de dommage direct ou indirect résultant de l'utilisation du Service</li>
          <li>En cas d'interprétation erronée des données par l'Utilisateur</li>
          <li>En cas de décision prise sur la base des informations du Service</li>
          <li>En cas de non-détection d'une évolution réglementaire</li>
          <li>En cas de données obsolètes ou non mises à jour</li>
        </ul>
      </section>

      {/* Section 7 - Mise à jour des données */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          7. Mise à jour des données
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-blue-800">
          <p>
            RISK-DATA s'efforce de maintenir ses données à jour dans des délais
            raisonnables. Toutefois, l'utilisateur est informé que :
          </p>
          <ul className="list-disc list-inside space-y-1 mt-2">
            <li>
              Les données présentées peuvent ne pas refléter les dernières
              évolutions réglementaires ou scientifiques
            </li>
            <li>
              Un délai peut exister entre la publication officielle d'une
              information et son intégration dans l'outil
            </li>
            <li>
              L'utilisateur doit vérifier les informations auprès des sources
              officielles pour tout usage réglementaire ou décisionnel
            </li>
          </ul>
        </div>
      </section>

      {/* Section 8 - Propriété intellectuelle */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          8. Propriété intellectuelle
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>

      {/* Section 9 - Modification des CGU */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          9. Modification des CGU
        </h2>
        <p className="text-gray-600">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
      </section>

      {/* Section 10 - Droit applicable */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          10. Droit applicable et juridiction compétente
        </h2>
        <p className="text-gray-600 mb-4">
          [TEXTE À VALIDER PAR HUMAIN/JURISTE]
        </p>
        <p className="text-gray-600">
          Les présentes CGU sont soumises au droit français. Tout litige
          relatif à leur interprétation ou leur exécution sera de la compétence
          exclusive des tribunaux de [À COMPLÉTER].
        </p>
      </section>
    </LegalPageLayout>
  )
}
